
import {Injectable} from "@angular/core";
import {Restaurant} from "../../model/restaurant";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";

import {RestaurantService} from "./restaurant.service";
import {Observable} from "rxjs/Observable";
import 'rxjs/Rx';




@Injectable()
export class RestaurantResolver implements Resolve<Restaurant>{
  private restaurantKey;

  constructor(private restaurantservice:RestaurantService){}


  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {

    this.restaurantKey = route.params['id'];

     // console.log(this.restaurantKey);


    const restaurant$ = this.restaurantservice.getRestaurantByKey(this.restaurantKey)
      .map (results => results)
    .first();

    return restaurant$;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/restaurant/restaurant-resolver.ts